<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="text-center p-4" v-if="!detail">กำลังโหลด</div>
    <div class="wrapper" v-else>
      <div class="d-flex justify-content-between mb-4" v-if="showCancelAction">
        <sc-button
          variant="danger"
          @click="handleClickCancel"
          :disabled="disabledCancelButton"
          v-if="showCancelButton"
        >{{ cancelButtonText }}</sc-button>
        <sc-button
          variant="warning"
          @click="handleClickUnsubscribe"
          :disabled="disabledUnsubscribeButton || isViewOnlyByRole"
          v-if="showUnsubscribeButton"
        >ยกเลิกการเป็นสมาชิก Unsubscribe</sc-button>
      </div>
      <div class="d-flex justify-content-end mb-4" v-if="showRevokeAction">
        <sc-button
          variant="secondary"
          v-bind:disabled="isViewOnlyByRole"
          @click="handleClickRevoke"
        >Undo การยกเลิก</sc-button>
      </div>
      <div class="row">
        <div class="col-3 member">
          <p class="font-red" v-if="subscriber.isUserForOfflinePurchaseByAdmin === true">*ซื้อนอกระบบลูกค้าไม่โหลด App</p>
          <p>ชื่อ (ID: {{ subscriber.userId }})</p>
          <h6>{{ subscriber.name }}</h6>
          <p>บ้านเลขที่</p>
          <h6 v-show="hasHome">{{ subscriber.home.addressNumber }}</h6>
          <sc-button
            variant="primary"
            size="sm"
            v-show="!$isCallCenter && !hasHome"
            v-bind:disabled="isViewOnlyByRole"
            @click="handleShowSelectHomeDialog"
          >เลือกบ้าน</sc-button>
          <p>โครงการ</p>
          <h6>{{ subscriber.home.project }}</h6>
          <p>เบอร์โทรศัพท์</p>
          <h6>{{ subscriber.phoneNumber }}</h6>
          <p>E-mail</p>
          <h6>{{ subscriber.email }}</h6>
          <p>เลขบัตรประชาชน / Passport No.</p>
          <div class="mb-3">
            <button
              v-if="!isHiddenDrecryptButton"
              class="button-content"
              @click="handleDecryptIdCard"
            >
              <span style="font-weight: bold">แสดงข้อมูล</span>
              <i class="fa fa-eye-slash" aria-hidden="true"></i>
            </button>
            <div v-if="subscriber.identifierNo" class="identifier-id">
              {{  subscriber.identifierNo }}
            </div>
          </div>
          <p>วันเกิด</p>
          <h6>{{ subscriber.dateOfBirth }}</h6>
          <div class="row mb-4">
            <div class="col-lg-12" v-if="histories[0] && histories[0].invoiceId">
              <p>ข้อมูลใบกำกับภาษี</p>
              <div>{{ addressTaxInvoice.line1 }}</div>
              <div>{{ addressTaxInvoice.line2 }}</div>
              <div>
                <sc-button
                  variant="primary"
                  size="sm"
                  @click="handleClickListAddressButton"
                  v-bind:disabled="isViewOnlyByRole"
                  v-if="isShowTaxInvoiceButton"
                >จัดการที่อยู่</sc-button>
                <sc-button
                  variant="danger"
                  size="sm"
                  v-if="isShowTaxInvoiceButton &&
                  addressTaxInvoice.line1 &&
                  this.histories[0].showSendReceiptButton &&
                  !this.histories[0].showNoReceiptMessage"
                  @click="handleClickCancelUserTaxInvoiceByTransactionButton"
                >ยกเลิกข้อมูลใบกำกับภาษี</sc-button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-9 info">
          <div class="row">
            <div class="col col-lg-6">
              <div class="alert alert-danger" v-if="alertDialog.isShow">{{ alertDialog.message }}</div>
              <div class="id">
                <div>
                  <div class="sub-id">Subscription ID:</div>
                  <div class="fontsize-14">{{ subscriber.id }}</div>
                </div>
                <div>
                  <sc-button
                    @click="handleClickToSubscriberReportPage(subscriber.id)"
                    variant="orange-cc"
                    size="sm"
                  >การซืื้อทั้งหมดของรายการนี้</sc-button>
                </div>
              </div>
              <template v-if="showNote">
                <p>หมายเหตุ: {{ note.label }}</p>
                <h6>{{ note.content }}</h6>
              </template>
              <p></p>
              <p>สถานะ</p>
              <h6>{{ status }}</h6>
              <template v-if="showPaymentStatus">
                <p>เลขที่ใบสั่งซื้อ</p>
                <h6>{{ subscriber.invoice.id }}</h6>
                <p>สถานะการชำระเงิน</p>
                <h6>{{ paymentStatus }}</h6>
              </template>
              <p>ซื้อเมื่อ</p>
              <h6>{{ subscriber.purchasedAt }}</h6>
              <template v-if="showCancelledDate">
                <p>ยกเลิกเมื่อ</p>
                <h6>{{ subscriber.cancelledAt }}</h6>
              </template>
              <template v-if="showExtras">
                <p>ข้อมูลเพิ่มเติม</p>
                <p>{{ registrationForm.title }}</p>
                <div v-for="extra in registrationForm.extras" :key="extra.key" class="extra">
                  <p>{{ extra.label }}</p>
                  <div v-for="input in extra.inputs" :key="input.key">
                    <p>{{ input.label }}</p>
                    <h6 v-if="input.isText">{{ input.value }}</h6>
                    <a
                      v-else
                      :href="input.value"
                      target="_blank"
                      class="sc-button sm secondary"
                    >ดูรูป</a>
                  </div>
                </div>
              </template>
              <p>ประวัติการต่ออายุ</p>
              <div class="history" :key="history.id" v-for="history in histories">
                <div class="no mb-1">
                  รอบที่ {{ history.no }}
                  <span
                    style="font-weight: normal"
                    v-if="history.isFreeTrial"
                  >(ทดลองใช้)</span>
                </div>
                <div class="row mb-2" v-if="!history.isFreeTrial">
                  <div class="col-6">
                    <strong>เลขที่ใบแจ้งหนี้</strong>
                    <br />
                    {{ history.invoiceNo }}
                  </div>
                  <div class="col-6">
                    <strong>เลขที่ใบเสร็จ</strong>
                    <br />
                    {{ history.receiptNo }}
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-6">
                    <strong>หมดอายุเมื่อ</strong>
                    <i v-if="detail.current_package.is_expire_after_appointment" style="color:red"><br />
                      <small>*วันเปลี่ยนแปลงตามการนัดครั้งที่ 1</small>
                    </i>
                    <br />
                    {{ history.expiredAt }}
                  </div>
                  <div class="col-6">
                    <strong>มีผลเมื่อ</strong>
                    <i v-if="detail.current_package.is_expire_after_appointment" style="color:red"><br />
                      <small>*วันเปลี่ยนแปลงตามการนัดครั้งที่ 1</small>
                    </i>
                    <br />
                    {{ history.effectivedAt }}
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-6">
                    <strong>ช่องทางชำระเงิน</strong>
                    <br />
                    {{ history.paymentChannel }}
                  </div>
                  <div class="col-6">
                    <strong>เลขที่ใบงานแจ้งซ่อม</strong>
                    <br />
                    <input
                      type="text"
                      class="form-control"
                      :disabled="history.canNotEditMaintenanceRequest"
                      v-model="history.maintenanceRequest"
                      v-on:keyup.enter="saveMaintenanceRequest(history)"
                    >
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-lg-4">
                    <strong>ยอดที่ชำระ</strong>
                    <br />
                    {{ history.total }}
                    {{ subscriber.package.billingCyclePerUnit }}
                  </div>
                </div>
                <div class="row" v-if="!history.isFreeTrial && !history.isRJB2BChannel">
                  <div class="col-6" v-if="!history.isCancelled">
                    <strong>ใบกำกับภาษี</strong>
                    <br />
                    <template v-if="history.showNoReceiptMessage">
                      Subscription นี้ไม่ออกใบกำกับภาษี</template
                    >
                    <template
                      v-else-if="history.showSendReceiptButton && $isCallCenter"
                      >ยังไม่ออกใบกำกับภาษี</template
                    >
                    <sc-button
                      variant="primary"
                      size="sm"
                      v-if="
                        !$isCallCenter &&
                          history.showSendReceiptButton &&
                          !history.showNoReceiptMessage
                      "
                      :route="history.sendReceiptRoute"
                      >{{ history.textToReceiptPage }}</sc-button
                    >

                    <template v-else-if="!history.showNoReceiptMessage">
                      <sc-button
                        v-if="
                          !$isCallCenter
                        "
                        variant="primary"
                        size="sm"
                        :route="history.sendReceiptRoute"
                      >{{ history.textToReceiptPage }}</sc-button
                      >

                      <a
                        v-if="!history.isOfflineReceipt || (history.isOfflineReceipt && history.offlinePdfKey)"
                        :href="history.pdfUrl"
                        class="view-receipt"
                        target="_blank"
                        >ดูใบกำกับภาษี</a
                      >
                    </template>
                  </div>
                  <div v-else class="col-6">
                    <strong>ใบกำกับภาษี</strong>
                    <br />ถูกยกเลิก
                  </div>
                  <div v-if="history.canRefund" class="col-lg-6">
                    <br />
                    <sc-button
                      size="sm"
                      variant="primary"
                      @click="handleClickRefund(history.id)"
                      >Refund
                    </sc-button>
                  </div>
                  <div v-if="history.cancelledAt" class="col-lg-6">
                    <div class="font-red"> ยกเลิกเมื่อ{{ history.cancelledAt }}</div>
                    <input
                      type="text"
                      class="form-control"
                      v-model="history.billingRefundRemark"
                      v-on:keyup.enter="saveRefundRemark(history)"
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col col-lg-6 info">
              <p>แพ็กเกจ</p>
              <h6>
                <router-link class="name" :to="routePackage">{{ subscriber.package.name }}</router-link>
                <br />
                <small>
                  {{ subscriber.package.qualityText }}
                </small>
                <br />
                <small>
                  <span class="original-price" v-if="originalPrice">{{ originalPrice }}</span>
                  {{ subscriber.package.billingCycle }}
                </small>
                <br />
                (ID: {{ this.detail.current_package.id }})
              </h6>
              <sc-button
                v-if="showBookServiceButton"
                @click="handleClickSubscriberBookServicePage(subscriber.id)"
                variant="secondary"
                :class="!hasHome ? 'disabled' : ''"
              >นัดบริการ</sc-button>
              <p class="font-red" v-if="!hasHome">กรุณาเลือกแพ็กเกจเข้าบ้าน</p>
              <p>บริการ</p>
              <list-service-appointment
                v-for="service in subscriber.services"
                :key="service.id"
                :qualityUnit="subscriber.qualityUnit"
                v-bind="service"
              ></list-service-appointment>
            </div>
          </div>
          <list-tax-invoices
            v-if="isShowAddressTaxInvoice"
            :homeId="this.detail.home_id"
            :isSentReceipt="this.histories[0].isReceiptSigned"
            :selectedTaxInvoice="this.detail.user_tax_invoice"
            :value="this.subscriber.userId"
            class="text-invoice-list"
            @addressTaxInvoice="newAddressTaxInvoice"
            @confirm="handleConfirmAddressTaxInvoice"
            @selectTaxInvoice="selectAddressToInvoice"
          ></list-tax-invoices>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="selectHomeDialog.isShow"
      title="เลือกบ้านที่จะผูกกับแพ็กเกจ"
      width="50%"
      @close="clearSelectHomeDialog"
    >
      <div v-for="home in selectHomeDialog.homes" :key="home.id">
        <el-radio v-model="selectHomeDialog.selectedHome" :label="home"
          ><strong>บ้านเลขที่:</strong> {{ home.addressNo }}
          <strong>โครงการ:</strong> {{ home.projectName }}</el-radio
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <sc-button @click="clearSelectHomeDialog">ยกเลิก</sc-button>
        <sc-button variant="primary" @click="handleBindSupportedHome">ยืนยัน</sc-button>
      </span>
    </el-dialog>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { DateTime } from "luxon";
import { baanRueJaiClient } from "@/dependencies";
import { getDurationAppointmentTimeText, toLocaleTH } from "@/lib/dateTime";
import {
  permissionRole,
  reversePaymentStatus,
  subscriptionStatus
} from "@/lib/mapper";
import ServiceListItem from "../../services/components/ServiceListItem";
import { isEmpty, isNil } from "ramda";
import Confirm from "@/components/helper/dialog/Confirm";
import ListServiceAppointment from "../components/ListServiceAppointment";
import { Dialog, Input, Radio } from "element-ui";
import {
  convertBathToStangAndRoundTwoDecimal,
  formatCurrencyAndTwoDecimalsString,
  formatNumber
} from "@/lib/formatter";
import { getPDF } from "@/god";
import ListTaxInvoices from "../components/ListTaxInvoices"
import { backendAdminClient } from "@/dependencies";

export default {
  components: {
    PageWrapper,
    ScButton,
    ServiceListItem,
    Confirm,
    ListServiceAppointment,
    "el-dialog": Dialog,
    "el-radio": Radio,
    "el-input": Input,
    getPDF,
    ListTaxInvoices
  },
  data() {
    const title = "รายละเอียดสมาชิก";
    const selectHomeDialog = {
      isShow: false,
      homes: [],
      selectedHome: null
    };

    const permission = JSON.parse(localStorage.getItem("adminRolePermission")) || null;

    return {
      title,
      detail: null,
      subscriber: null,
      payment: null,
      histories: [],
      selectHomeDialog,
      permission,
      isShowAddressTaxInvoice: false,
      newSelectAddress: null,
      decryptedId: null,
      isHiddenDrecryptButton: false
    };
  },
  computed: {
    originalPrice() {
      const price = this.detail.current_package.original_price;

      if (!price) {
        return;
      }

      return `${(formatCurrencyAndTwoDecimalsString(price / 100))} บาท`;
    },
    note() {
      const label = this.detail.current_package.note_label;
      const firstHistory = this.detail.histories[
        this.detail.histories.length - 1
      ];
      const content =
        firstHistory && firstHistory.invoice && firstHistory.invoice.note;

      return {
        label,
        content
      };
    },
    showExtras() {
      return !!this.detail.registration_form;
    },
    registrationForm() {
      const form = this.detail.registration_form;
      const title = form.title;

      return {
        title,
        extras: this.extras
      };
    },
    extras() {
      return this.detail.registration_form.sections.map(({ title, inputs }) => {
        const label = title;
        const key = title;

        return {
          key,
          label,
          inputs: inputs.map(input => {
            const isImage = input.type === "CITIZEN_CARD_IMAGE";
            const isText = !isImage;

            return {
              key: input.title,
              label: input.title,
              value: input.value || "-",
              isImage,
              isText
            };
          })
        };
      });
    },
    showNote() {
      return this.note.label && this.note.content;
    },
    showBookServiceButton() {
      return true;
    },
    showCancelAction() {
      if (this.$isCallCenter) {
        return false;
      }

      return this.showCancelButton || this.showUnsubscribeButton;
    },
    showRevokeAction() {
     if (
        this.$isCallCenter
        || (
          this.detail.histories[0].expired_at < new Date().toISOString() &&
          this.status === subscriptionStatus.UNSUBSCRIBED
        ) || this.isBankTransfer
      ) {
        return false;
      }

      return this.showRevokeUnsubscribeButton;
    },
    showCancelButton() {
      return [
        subscriptionStatus.ACTIVE,
        subscriptionStatus.FREE_TRIAL,
        subscriptionStatus.ONE_TIME
      ].includes(this.status)
      || this.isBankTransfer
    },
    showCancelledDate() {
      return [
        subscriptionStatus.CANCELLED,
        subscriptionStatus.UNSUBSCRIBED,
        subscriptionStatus.EXPIRED
      ].includes(this.status) && !isNil(this.subscriber.cancelledAt);
    },
    showUnsubscribeButton() {
      return this.subscriber.canUnsubscribe;
    },
    showRevokeUnsubscribeButton() {
      return subscriptionStatus.UNSUBSCRIBED.includes(this.status);
    },
    disabledUnsubscribeButton() {
      return !this.showUnsubscribeButton;
    },
    disabledCancelButton() {
      const latestHistory = this.histories[0];
      const isLatestReceiptSigned =
        latestHistory && latestHistory.isReceiptSigned;

      const isStatusAndlatestReceiptSigned = !([
        subscriptionStatus.ACTIVE,
        subscriptionStatus.FREE_TRIAL,
        subscriptionStatus.ONE_TIME
      ].includes(this.status)) && isLatestReceiptSigned;

      return (isStatusAndlatestReceiptSigned && !this.isBankTransfer) || this.isViewOnlyByRole
    },
    alertDialog() {
      switch (this.status) {
        case subscriptionStatus.FREE_TRIAL:
          return {
            isShow: true,
            message: "ลูกบ้านทดลองใช้งาน"
          };
        case subscriptionStatus.UNSUBSCRIBED:
          return {
            isShow: true,
            message: "ลูกบ้านไม่ Sub ต่อ"
          };
        case subscriptionStatus.CANCELLED:
          return {
            isShow: false,
            message: "ยกเลิกทันที"
          };
        case subscriptionStatus.ACTIVE:
          return {
            isShow: false,
            message: ""
          };
        case subscriptionStatus.ONE_TIME:
          return {
            isShow: false,
            message: ""
          };
      }

      if (this.histories.length === 0) {
        return {
          isShow: false,
          message: ""
        };
      }

      const isReceiptSigned = this.histories[0].isReceiptSigned;

      if (!isReceiptSigned) {
        return {
          isShow: false,
          message: ""
        };
      }

      const isShow = isReceiptSigned;
      const date = this.histories[0].receiptSignedAt.toFormat(
        "dd MMM yyyy HH:mm"
      );

      const message = `ไม่สามารถ "ยกเลิกทันที" ได้ เนื่องจากออกใบเสร็จไปแล้ว เมื่อ ${date}`;
      return {
        isShow,
        message
      };
    },
    paymentStatus() {
      if (!this.payment) {
        return "กำลังโหลด";
      }

      if (this.payment === "F") {
        return "ไม่สามารถเรียกดูข้อมูลการชำระเงินได้";
      }

      return reversePaymentStatus[this.payment.status];
    },
    showPaymentStatus() {
      if (!this.status) {
        return false;
      }

      return (
        this.status !== subscriptionStatus.FREE_TRIAL && this.subscriber.invoice
      );
    },
    status() {
      if (this.detail === null) {
        return null;
      }

      return this.detail.status;
    },
    routePackage() {
      const id = this.detail.current_package.id

      return { name: "PackageDetailPage", params: { id } };
    },
    isSCBPayment() {
      return this.histories.some(
        history =>
          history.paymentChannel === "SCB_EASY" ||
          history.paymentChannel === "SCB_QR" ||
          history.paymentChannel === "BANK_TRANSFER"
      );
    },
    cancelButtonText() {
      return this.isSCBPayment ? "ยกเลิก" : "ยกเลิกและคืนเงิน";
    },
    isBankTransfer() {
      return this.histories[0] && this.histories[0].paymentChannel === 'BANK_TRANSFER'
      && this.status !== subscriptionStatus.CANCELLED
    },
    hasHome() {
      return !isEmpty(this.subscriber.home.addressNumber)
    },
    addressTaxInvoice() {
      const newTaxInvoice = this.newSelectAddress;
      const taxInvoice = this.detail.user_tax_invoice;

      let line1
      if (newTaxInvoice) {
        line1 = newTaxInvoice.line1;
      } else if (taxInvoice) {
        line1 = [ taxInvoice.house_no, taxInvoice.street_address ].join(" ");
      }

      let line2
      if (newTaxInvoice) {
        line2 = newTaxInvoice.line2;
      } else if (taxInvoice) {
        const tumbon = `ตำบล${taxInvoice.tumbon}`
        const amphur = `อำเภอ${taxInvoice.amphur}`

        line2 = [
          tumbon,
          amphur,
          taxInvoice.province,
          taxInvoice.zip_code
        ].join(" ");
      }

      return { line1, line2 };
    },
    isShowTaxInvoiceButton() {
      return !this.$isCallCenter
        && this.histories && this.histories.length > 0
    },
    isViewOnlyByRole() {
      const roles = ["AC", 'CC']
      return roles.includes(this.permission.role)
    }
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      await this.setupData();

      await this.setupHistories();
      await this.setupPaymentStatus();
    },
    async setupPaymentStatus() {
      if (this.status === subscriptionStatus.FREE_TRIAL) {
        return;
      }

      if (!this.subscriber.invoice) {
        return;
      }

      try {
        const data = await this.fetchPaymentStatus();

        this.payment = data;
      } catch (error) {
        console.error(error);

        this.payment = "F";
      }
    },
    async setupData() {
      const data = await this.fetchData();
      this.detail = data;

      const id = data.id;
      const userId = data.owner.user_id;
      const userName = `${data.owner.first_name} ${data.owner.last_name}`;
      const phoneNumber = data.owner.mobile_number || "-";
      const email = data.owner.user.email;
      const isUserForOfflinePurchaseByAdmin = data.owner.is_user_for_offline_purchase_by_admin;
      const identifierNo =
        data.owner.citizen_id !== ""
          ? data.owner.citizen_id
          : data.owner.passport_number;
      const dateOfBirth = !isNil(data.owner.birth_date)
        ? toLocaleTH(DateTime.fromISO(data.owner.birth_date)).toFormat(
            "dd MMMM yyyy"
          )
        : "-";

      const home = {
        addressNumber: data.home ? data.home.address_no : "",
        project: data.project ? data.project.project_name : ""
      };
      const quality = data.quality || 1
      const totalPriceBeforeDiscount = data.total_price !== null && data.total_price >= 0
        ? convertBathToStangAndRoundTwoDecimal(data.total_price)
        : convertBathToStangAndRoundTwoDecimal((data.current_package.price) * quality);
      const price = formatCurrencyAndTwoDecimalsString(totalPriceBeforeDiscount);
      const billingCycle =
        data.current_package.billing_cycle > 1
          ? " " + data.current_package.billing_cycle.toLocaleString() + " "
          : " ";

      const cycleUnit = data.current_package.billing_cycle === 0 ? "ครั้ง" : "เดือน";
      const billingCyclePerUnit = ` /${billingCycle}${cycleUnit}`;
      const billingCycleText = `${price} บาท/${billingCyclePerUnit}`;
      const qualityText = `จำนวน ${quality} แพ็คเกจ`;

      const pack = {
        name: data.current_package.name,
        price,
        billingCycle: billingCycleText,
        noteLabel: data.current_package.note_label,
        qualityText,
        billingCyclePerUnit
      };
      const format = "dd MMMM yyyy HH:mm น.";
      const purchasedAt = toLocaleTH(
        DateTime.fromISO(data.purchased_at)
      ).toFormat(format);
      const expiredAt = toLocaleTH(DateTime.fromISO(data.expired_at)).toFormat(
        format
      );
      const cancelledAt =
       data.cancelled_at === data.expired_at
          ? toLocaleTH(DateTime.fromISO(data.cancelled_at)).toFormat(format)
          : null;

      const invoice = data.invoice
        ? {
            id: data.invoice.id.toString().padStart(12, "0")
          }
        : undefined;
      const receipt = data.receipt
        ? {
            id: data.receipt.id.toString().padStart(12, "0"),
            signedAt:
              data.receipt && data.receipt.signed_at
                ? toLocaleTH(DateTime.fromISO(data.receipt.signed_at)).toFormat(
                    "dd MMMM yyyy HH:mm น."
                  )
                : null
          }
        : data.receipt;
      const services = data.services.map(service => {
        const {
          id,
          name,
          short_description: shortDescription,
          description,
          icon: iconUrl,
          quota,
          main_option_title: mainOptionTitle,
          extra_option_titles: extraOptionTitles
        } = service;
        const provider = {
          ...service.provider,
          logoUrl: service.provider.logo_url
        };
        const route = { name: "ServiceDetailPage", params: { id } };
        const appointmentCount = data.appointment_count[id]
          ? data.appointment_count[id]
          : 0

        const totalAppointment = data.total_appointment[id]
          ? data.total_appointment[id]
          : 0;
        const currentAppointmentDateEnd = data.current_appointment_date_end[id]
          ? data.current_appointment_date_end[id]
          : null;

        const currentAppointmentTime = getDurationAppointmentTimeText(
          data.current_appointment_date[id],
          currentAppointmentDateEnd
        );

        const currentAppointmentDateTime = data.current_appointment_date[id]
          ? toLocaleTH(DateTime.fromISO(data.current_appointment_date[id]))
              .toFormat("dd MMMM yyyy")
          : null;

        let currentAppointmentDate = `ไม่มีการนัด`
        if (currentAppointmentDateTime && currentAppointmentTime) {
          currentAppointmentDate = `${currentAppointmentDateTime} ${currentAppointmentTime}`
        } else if (currentAppointmentDateTime) {
          currentAppointmentDate = currentAppointmentDateTime
        }

        return {
          id,
          iconUrl,
          name,
          shortDescription,
          description,
          provider,
          route,
          quota,
          appointmentCount,
          currentAppointmentDate,
          totalAppointment,
          mainOptionTitle,
          extraOptionTitles
        };
      });

      const effectivedAt = toLocaleTH(
        DateTime.fromISO(data.effectived_at)
      ).toFormat("dd MMMM yyyy HH:mm น.");
      const canUnsubscribe = data.can_unsubscribe;

      const subscriber = {
        id,
        userId: userId,
        name: userName,
        phoneNumber,
        email,
        identifierNo,
        dateOfBirth,
        home,
        package: pack,
        purchasedAt,
        expiredAt,
        cancelledAt,
        effectivedAt,
        invoice,
        receipt,
        services,
        qualityUnit: `จำนวน ${quality} หน่วย`,
        isUserForOfflinePurchaseByAdmin,
        canUnsubscribe
      };

      this.subscriber = subscriber;
    },
    async setupHistories() {
      if (!this.detail) {
        this.histories = [];
      }

      const isPermissionCallCenter = this.permission
        && this.permission.role === (permissionRole.CC || permissionRole.LMC);

      this.histories = await Promise.all(this.detail.histories.map(async (h, i) => {
        const isReceiptSigned = h.receipt
          ? Boolean(h.receipt.signed_at)
          : false;
        const no = Math.abs(i - this.detail.histories.length);
        const invoiceNo = h.invoice
          ? h.invoice.id.toString().padStart(12, "0")
          : null;
        const receiptNo =
          (h.receipt && h.receipt.document_number) || "ยังไม่ได้ออกใบเสร็จ";
        const isFreeTrial = invoiceNo === null && receiptNo === null;
        const isCancelled = h.cancelled_at === h.expired_at;
        const showSendReceiptButton = !isFreeTrial && !isCancelled && !isReceiptSigned;
        const sendReceiptRoute = !isFreeTrial && !isCancelled
          ? {
              name: "ReceiptDetailPage",
              params: { id: h.receipt.id }
            }
          : null;
        let paymentChannel = h.invoice
          ? h.invoice.transaction.payment_channel
          : 'Free Trial';

        if (h.receipt.total_coin_amount) {
          const totalCoinAmount = formatNumber(h.receipt.total_coin_amount)
          paymentChannel += ` + MNCs / ${totalCoinAmount} บาท`
        }
        const isVoid = !isNil(h.receipt.void_at);
        const hasDocumentNumber = !isNil(h.receipt.document_number);
        const showNoReceiptMessage = isVoid && !hasDocumentNumber;

        // call center สามารถแก้ไข "เลขที่ใบงานแจ้งซ่อม" ได้ครั้งเดียวเท่านั้น
        const canNotEditMaintenanceRequest = isPermissionCallCenter && h.maintenance_request;

        const pdfUrl = h.receipt && h.receipt.is_offline_receipt && h.receipt.offline_pdf_key
          ? await getPDF(h.receipt.offline_pdf_key, "receipt")
          : h.receipt && h.receipt.pdf_url

        let textToReceiptPage = 'ออกใบกำกับภาษี'
        if (h.receipt && h.receipt.is_offline_receipt) {
          textToReceiptPage = 'ออกใบกำกับภาษีนอกระบบแล้ว'
        } else if (h.receipt && h.receipt.signed_at && h.receipt.document_number) {
          textToReceiptPage = 'ออกใบกำกับภาษีแล้ว'
        }
        let canRefund = false
        const adminRoleCanRefund = [
          permissionRole.ADMIN,
          permissionRole.SADMIN
        ]
        if (
          h.can_refund && 
          adminRoleCanRefund.includes(this.permission.role)
          ) {
          canRefund = true
        }

        const total = `${(formatCurrencyAndTwoDecimalsString(h.receipt.total / 100))} บาท`;
        const isRJB2BChannel = h.invoice
          && h.invoice.transaction
          ? h.invoice.transaction.payment_channel === 'RJB2B'
          : false

        return {
          no,
          invoiceNo,
          receiptNo,
          id: h.id,
          cancelledAt: h.cancelled_at && (h.cancelled_at === h.expired_at)
            ? toLocaleTH(DateTime.fromISO(h.cancelled_at)).toFormat("dd MMMM yyyy")
            : null,
          effectivedAt: toLocaleTH(DateTime.fromISO(h.effectived_at)).toFormat(
            "dd MMMM yyyy"
          ),
          expiredAt: toLocaleTH(DateTime.fromISO(h.expired_at)).toFormat(
            "dd MMMM yyyy"
          ),
          canRefund,
          paymentChannel,
          isReceiptSigned,
          receiptSignedAt:
            h.receipt && h.receipt.signed_at
              ? toLocaleTH(DateTime.fromISO(h.receipt.signed_at))
              : null,
          isCancelled,
          showSendReceiptButton,
          sendReceiptRoute,
          isFreeTrial,
          pdfUrl,
          showNoReceiptMessage,
          maintenanceRequest: h.maintenance_request,
          canNotEditMaintenanceRequest,
          isOfflineReceipt: h.receipt && h.receipt.is_offline_receipt,
          offlinePdfKey: h.receipt && h.receipt.offline_pdf_key,
          textToReceiptPage,
          invoiceId: h.invoice_id,
          total: total,
          billingRefundRemark: h.billing_refund_remark,
          isRJB2BChannel
        };
      }));
    },
    async fetchData() {
      const { id } = this.$route.params;
      try {
        const response = await baanRueJaiClient.admin.subscriptions.subscribers.get(
          id
        );

        return response.data.result;
      } catch (error) {
        alert("ไม่สามารถเรียกดูข้อมูลได้ กรุณาลองใหม่");
        throw error;
      }
    },
    async fetchPaymentStatus() {
      const { id } = this.$route.params;
      try {
        const response = await baanRueJaiClient.admin.subscriptions.subscribers.getPaymentStatus(
          id
        );

        return response.data.result;
      } catch (error) {
        throw error;
      }
    },
    async handleClickCancel() {
      if (!confirm("ยืนยันการยกเลิกทันที")) {
        return;
      }

      try {
        const { id } = this.$route.params;
        const response = await baanRueJaiClient.admin.subscriptions.subscribers.postCancel(
          id
        );

        alert(
          this.isSCBPayment
            ? "ยกเลิกเรียบร้อย กรุณาติดต่อฝ่ายบัญชี เพื่อทำเรื่องคืนเงินนอกระบบบ้านรู้ใจ"
            : "ยกเลิกเรียบร้อย"
        );

        await this.setup();
      } catch (err) {
        alert("การยกเลิกผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      }
    },
    async handleClickUnsubscribe() {
      if (!confirm("ยืนยันยกเลิกการเป็นสมาชิก")) {
        return;
      }

      try {
        const { id } = this.$route.params;
        const response = await baanRueJaiClient.admin.subscriptions.subscribers.postUnsubscribe(
          id
        );

        await this.setupData();
        alert("ยกเลิกการเป็นสมาชิกเรียบร้อย");
      } catch (err) {
        alert("ยกเลิกการเป็นสมาชิก ผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      }
    },
    async handleClickRefund(historyId) {
      if (!confirm("ยืนยันการคืนเงินใช่หรือไม่?")) {
        return;
      }

      try {
        const response = await baanRueJaiClient.admin.subscriptions.subscribers.postRefund(
          historyId
        );

        await this.setup();
        alert("Refund เรียบร้อย");
      } catch (err) {
        alert("Refund ผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      }
    },
    async handleClickViewReceiptButton(receiptNo) {
      try {
        const id = receiptNo;
        const response = await baanRueJaiClient.admin.subscriptions.receipts.get(
          id
        );

        window.open(response.data.result, "_blank");
      } catch (err) {
        alert("ไม่สามารถดูใบกำกับภาษีได้ในขณะนี้ิ");
        console.error(err);
      }
    },
    async handleClickSeeImage(imageKey) {
      const response = await baanRueJaiClient.downloadImage(imageKey);

      window.open(response.data.url, "_blank");
    },
    async handleClickRevoke() {
      try {
        const { id } = this.$route.params;

        const response = await baanRueJaiClient.admin.subscriptions.subscribers.postRevokeUnsubsribe(
          id
        );

        await this.setupData();
        alert("Undo การยกเลิกเรียบร้อยแล้ว");
      } catch (err) {
        alert("ไม่สามารถ Undo การยกเลิกได้");
        console.error(err);
      }
    },
    handleShowSelectHomeDialog() {
      this.selectHomeDialog.isShow = true;

      const subscriberId = this.subscriber.id;

      baanRueJaiClient.admin.subscriptions
        .getSupportedHomes(subscriberId)
        .then(response => {
          this.selectHomeDialog.homes = response.data.result.map(home => ({
            id: home.id,
            addressNo: home.address_no,
            projectName: home.project.name
          }));
        })
        .catch(error => {
          const message = error.response
            ? error.response.data.message
            : error.message;

          alert(`ไม่สามารถเรียกรายการบ้านได้เนื่องจาก ${message}`);

          console.error(error);
        });
        this.subscriber.identifierNo = '';
        this.isHiddenDrecryptButton = false;
    },
    handleBindSupportedHome() {
      if (isNil(this.selectHomeDialog.selectedHome)) {
        alert("กรุณาเลือกบ้านสำหรับผูกกับแพ็กเกจ");
        return;
      }
      if (
        !confirm(
          `ยืนยันการผูกแพ็กเกจนี้กับ
          บ้านเลขที่: ${this.selectHomeDialog.selectedHome.addressNo}
          โครงการ: ${this.selectHomeDialog.selectedHome.projectName}\n**กรุณาตรวจสอบบ้านที่เลือก หากทำการยืนยันแล้วจะไม่สามารถกลับมาแก้ไขได้อีก**`
        )
      ) {
        return;
      }

      const subscriberId = this.subscriber.id;
      const params = {
        home_id: this.selectHomeDialog.selectedHome.id
      };

      baanRueJaiClient.admin.subscriptions
        .bindSupportedHome(subscriberId, params)
        .then(() => {
          alert("ผูกแพ็กเกจกับบ้านสำเร็จ");

          this.selectHomeDialog.isShow = false;
          this.selectHomeDialog.homes = [];
          this.selectHomeDialog.selectedHome = null;

          this.setupData();
        })
        .catch(error => {
          const message = error.response
            ? error.response.data.message
            : error.message;

          alert(`ผูกแพ็กเกจกับบ้านไม่สำเร็จเนื่องจาก ${message}`);

          console.error(error);
        });
    },
    clearSelectHomeDialog() {
      this.selectHomeDialog.isShow = false;
      this.selectHomeDialog.homes = [];
      this.selectHomeDialog.selectedHome = null;
    },
    async saveMaintenanceRequest(history) {
      if (!history.maintenanceRequest || history.maintenanceRequest === "") {
        alert("ไม่สามารถบันทึกค่าว่างได้");
        return;
      }

      try {
        await baanRueJaiClient.admin.subscriptions.subscribers.putMaintenanceRequest(
          history.id,
          { maintenanceRequest: history.maintenanceRequest }
        );

        alert("บันทึก เลขที่ใบงานแจ้งซ่อม สำเร็จ");
        await this.setup();
      } catch (error) {
        alert("ไม่สามารถแก้ไข เลขที่ใบงานแจ้งซ่อม ได้");
        await this.setup();
      }
    },
    async handleClickListAddressButton() {
      const params = {
        userId: this.subscriber.userId
      };

      await baanRueJaiClient.admin.subscriptions.subscribers.postGenerateUserTaxInvoice(
        params
      );

      this.isShowAddressTaxInvoice = true;
      this.subscriber.identifierNo = '';
      this.isHiddenDrecryptButton = false;
    },
    handleClickSubscriberBookServicePage (id) {
      console.log(id)
      this.$router.push({
              name: "SubscriberBookServicePage",
              params: { id: id }
            });
    },
    handleConfirmAddressTaxInvoice() {
      this.isShowAddressTaxInvoice = false;
    },
    newAddressTaxInvoice(value) {
      this.newSelectAddress = value;
    },
    async selectAddressToInvoice(
      taxInvoiceId,
      isChangeRecurringTaxAddressEveryMonth
    ) {
      try {
        const history = this.histories[0]
        await baanRueJaiClient.admin.subscriptions.subscribers.putTaxInvoiceToCurrentInvoice(
          {
            invoiceId: history.invoiceId,
            taxInvoiceId,
            isChangeRecurringTaxAddressEveryMonth,
            isSentReceipt: history.isReceiptSigned
          }
        );

        alert("เปลี่ยนข้อมูลใบกำกับสำหรับใบงานเรียบร้อย");
      } catch (error) {
        alert("ไม่สามารถ เปลี่ยนข้อมูลใบกำกับสำหรับใบงานได้");
        console.error(error);
      }

      await this.setup();
    },
    async handleClickCancelUserTaxInvoiceByTransactionButton() {
      if (!confirm("คุณต้องการยกเลิกข้อมูลใบกำกับภาษีหรือไม่")) {
        return;
      }

      try {
        await baanRueJaiClient.admin.subscriptions.subscribers.putInvoiceToCancelUserTaxInvoice(
          this.histories[0].invoiceId
        );

        alert("ยกเลิกข้อมูลใบกำกับภาษีเรียบร้อย");
        this.newSelectAddress = null;
        this.detail.user_tax_invoice = null;
      } catch (error) {
        alert("ไม่สามารถ ยกเลิกข้อมูลใบกำกับภาษีได้");
        console.error(error);
      }
    },
    async saveRefundRemark(history) {
      if (!history.billingRefundRemark || history.billingRefundRemark === "") {
        alert("ไม่สามารถบันทึกค่าว่างได้");
        return;
      }

      try {
        await baanRueJaiClient.admin.subscriptions.subscribers.putRefundRemarkRequest(
          history.id,
          { billing_refund_remark: history.billingRefundRemark }
        );

        alert("บันทึก สำเร็จ");
      } catch (error) {
        alert("ไม่สามารถแก้ไข ได้");
      } finally {
        await this.setup();
      }
    },
    handleClickToSubscriberReportPage() {
      this.$router.push({
        name: "SubscriberReportPage",
        query: { documentNumber: this.subscriber.id }
      });

    },
    async handleDecryptIdCard() {
      try {
       const subscriber_id = this.subscriber.id;
       const response = await backendAdminClient.subscriber.getDecryptedIdCard(subscriber_id);

        this.subscriber.identifierNo = response.data.result.id_card;
        this.isHiddenDrecryptButton = true;
      } catch (error) {
        alert("ไม่สามารถเข้าถึงได้");
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.info {
  border-left: $border;
}

.member h6,
.info h6 {
  margin-bottom: 20px;
}

.history {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: $border;

  font-size: 14px;

  .no {
    font-size: 16px;
    font-weight: bold;
  }
}

.view-receipt {
  display: inline-block;

  border-radius: $border-radius;
  border: $border;
  min-width: 0px;
  padding: 6px $space/ 2;

  font-size: 1rem;
  text-align: center;
  background: white;
  cursor: pointer;
  font-size: 14px;

  &:hover:not(:disabled) {
    border-color: $primary-color;

    text-decoration: none;

    background: #eee;
  }

  &:focus:not(:disabled) {
    outline: 0;

    border-color: $primary-color;
  }
}

.extra {
  margin-bottom: 0.5rem;

  > p,
  > h6 {
    font-size: 0.875rem;
  }

  > h6 {
    margin: 0;

    &:empty:before {
      content: "-";
    }
  }
}

.original-price {
  text-decoration: line-through;
}

.tar {
  text-align: right;
}

.invoice-list {
  top: 167px;
  left: 138px;
  width: 1164px;
  height: 684px;

  background: #fcfcfc;
  border-radius: 24px;
  opacity: 1;
}

.disabled {
  pointer-events: none;
  opacity: 0.2;
  background-color: rgb(155, 153, 153);
  border-bottom: 1px solid #696868;
}

.font-red {
  color: rgb(250, 102, 102);
}

.id {
  display: flex;
  justify-content: space-between;
}

.fontsize-14 {
  font-size: 14px;
}

.button-content {
  width: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  font-size: 16px;
  color: #4a4a4a;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
}

.button-content:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/subscribers/pages/SubscriberDetailPage.vue